import React, { useState, useEffect } from 'react';
import SparkMD5 from 'spark-md5';
import {
  S3Client,
  PutObjectCommand,
  PutObjectAclCommand,
  CreateMultipartUploadCommand,
  UploadPartCommand,
  CompleteMultipartUploadCommand,
  AbortMultipartUploadCommand,
} from '@aws-sdk/client-s3';
import { Progress, message } from 'antd';
import img from '../../img/shangChuan.svg'
import './oss.scss'

const s3Client = new S3Client({
  region: 'cn-north-1',
  endpoint: 'https://obs-bj3.cucloud.cn',
  credentials: {
    accessKeyId: 'E383DF555D764B8885903A7EC513BFB32563',
    secretAccessKey: '0D84E3F444A54C62B9E8305D903E35E71221',
  },
  forcePathStyle: true,
  tls: true,
});

const BUCKET = 'qiyeweike';

// Multipart requirements: every part except the last must be >= 5MB.
const PART_SIZE = 8 * 1024 * 1024; // 8MB

const UploadComponent = (props) => {
  const [selectedFile, setSelectedFile] = useState();

  const { onFuJian, ext, minTime, maxTime ,fuJian } = props;

  const courseCategory = props.kclb || props.category

  const [arr, setArr] = useState([])

  // 视频时长
  const [time, setTime] = useState()
  // 视频格式
  const [format, setFormat] = useState()

  //进度条

  const [percent, setPercent] = useState(0)

  const handleFileChange = (event) => {
    // if(selectedFile){
    //   message.error('一个上传一个')
    //   return
    // }

    if (props.buttonName == '请先删除') {
      message.error('请先删除原文件')
    } else {
      const url = event.target.value
      const index = url.lastIndexOf(".");
      const ext = url.substr(index + 1);
      setFormat(ext)

      let duration = 0;
      if (event.target.files[0]?.type.indexOf('video') > -1 || event.target.files[0]?.type.indexOf('audio') > -1) {
        const url = URL.createObjectURL(event.target.files[0]);
        const filelement = new Audio(url);
        filelement.addEventListener("loadedmetadata", function (_event) {
          duration = filelement.duration;
          setTime(duration)

          if (minTime < duration && duration < maxTime) {
            setSelectedFile(event.target.files[0]);
          } else {

            var file = document.getElementById('fileupload');
            file.value = '';

            message.error('请注意视频时长')
          }
        });
      } else {
        setSelectedFile(event.target.files[0]);
      }
    }
  };

  useEffect(() => {
    if (selectedFile) {
      handleUpload()
    }
  }, [selectedFile])

  const buildObjectKey = (file) => {
    if (props.title === '*') {
      return `qiyeweike2026/${props.province}/${courseCategory}/${file?.name}`
    }
    return `qiyeweike2026/${props.province}/${courseCategory}/${props.title}/${file?.name}`
  }

  const buildObjectUrl = (key) => {
    // URL path should be encoded; keep slashes.
    return `https://${BUCKET}.obs-bj3.cucloud.cn/${encodeURI(key)}`
  }

  const blobToUint8Array = async (blob) => {
    const ab = await blob.arrayBuffer()
    return new Uint8Array(ab)
  }

  const toBase64 = (bytes) => {
    let binary = ''
    const chunkSize = 0x8000
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize))
    }
    return btoa(binary)
  }

  const stripQuotes = (v) => String(v || '').replace(/"/g, '')
  const withQuotes = (v) => `"${stripQuotes(v)}"`

  const setPublicReadAcl = async (key) => {
    await s3Client.send(new PutObjectAclCommand({
      Bucket: BUCKET,
      Key: key,
      ACL: 'public-read',
    }))
  }

  const uploadSingle = async ({ file, key }) => {
    const bodyBytes = await blobToUint8Array(file)
    await s3Client.send(new PutObjectCommand({
      Bucket: BUCKET,
      Key: key,
      Body: bodyBytes,
      ContentType: file.type,
    }))

    // Upload succeeds first, then set object ACL to public-read.
    await setPublicReadAcl(key)

    setPercent(100)
    return buildObjectUrl(key)
  }

  const uploadMultipart = async ({ file, key }) => {
    let uploadId;
    try {
      const initRes = await s3Client.send(new CreateMultipartUploadCommand({
        Bucket: BUCKET,
        Key: key,
        ContentType: file.type,
      }))

      uploadId = initRes.UploadId
      if (!uploadId) {
        throw new Error('CreateMultipartUpload missing UploadId')
      }

      const parts = []
      let uploadedBytes = 0
      let partNumber = 1

      for (let start = 0; start < file.size; start += PART_SIZE) {
        const end = Math.min(start + PART_SIZE, file.size)
        const bodyBlob = file.slice(start, end)
        const bodyBytes = await blobToUint8Array(bodyBlob)
        const md5Hex = SparkMD5.ArrayBuffer.hash(bodyBytes.buffer)
        const md5Base64 = toBase64(Uint8Array.from(md5Hex.match(/.{1,2}/g).map((b) => parseInt(b, 16))))

        const partRes = await s3Client.send(new UploadPartCommand({
          Bucket: BUCKET,
          Key: key,
          PartNumber: partNumber,
          UploadId: uploadId,
          Body: bodyBytes,
          ContentMD5: md5Base64,
        }))

        // CompleteMultipartUpload must use the exact ETag returned by the storage service.
        // In browser, `ETag` is often undefined unless the bucket CORS rule exposes it.
        const etag = stripQuotes(partRes.ETag)
        if (!etag) {
          throw new Error('UploadPart response did not include ETag. Fix bucket CORS to ExposeHeaders: ETag, then retry.')
        }

        parts.push({
          ETag: etag,
          PartNumber: partNumber,
        })

        uploadedBytes += bodyBlob.size
        setPercent(Math.min(99, Math.floor((uploadedBytes / file.size) * 100)))
        partNumber += 1
      }

      const sortedParts = parts.sort((a, b) => a.PartNumber - b.PartNumber)

      const tryComplete = async (partsForComplete) => {
        await s3Client.send(new CompleteMultipartUploadCommand({
          Bucket: BUCKET,
          Key: key,
          UploadId: uploadId,
          MultipartUpload: { Parts: partsForComplete },
        }))
      }

      // Different S3-compatible providers differ on whether ETag in Complete must be quoted.
      // Try a couple of safe variants.
      try {
        await tryComplete(sortedParts)
      } catch (e1) {
        try {
          await tryComplete(sortedParts.map((p) => ({ ...p, ETag: withQuotes(p.ETag) })))
        } catch (e2) {
          await tryComplete(sortedParts.map((p) => ({ ...p, ETag: stripQuotes(p.ETag) })))
        }
      }

      // Upload completes first, then set object ACL to public-read.
      await setPublicReadAcl(key)

      setPercent(100)
      return buildObjectUrl(key)
    } catch (e) {
      if (uploadId) {
        try {
          await s3Client.send(new AbortMultipartUploadCommand({
            Bucket: BUCKET,
            Key: key,
            UploadId: uploadId,
          }))
        } catch (_) {
          // best-effort cleanup; ignore
        }
      }
      throw e
    }
  }

  const handleUpload = async () => {

    var file = document.getElementById('fileupload');


    if (!props.title) {
      message.error('请先填写课程名称')
      file.value = '';
      return
    }
    if (!courseCategory) {
      message.error('请先选择课程类别')
      file.value = '';
      return
    }

    if (ext && format != ext) {
      return message.error('请注意文件格式')
    }

    if (selectedFile) {
      setArr([selectedFile?.name])

      const uniqueFileName = buildObjectKey(selectedFile)

      try {
        setPercent(0)

        // For small files, use a single PutObject; otherwise use multipart.
        const fileUrl = selectedFile.size <= PART_SIZE
          ? await uploadSingle({ file: selectedFile, key: uniqueFileName })
          : await uploadMultipart({ file: selectedFile, key: uniqueFileName })

        if (props.buttonName == '教辅工具') {
          onFuJian(selectedFile.name, fileUrl)
        } else {
          props.url(fileUrl)
          props.Name(selectedFile.name)
        }

        message.success('资料上传成功')
        setSelectedFile(undefined)
        file.value = ''
      } catch (e) {
        console.error(e);
        message.error('上传失败')
        setSelectedFile(undefined)
        file.value = ''
      }
    } else {
      message.error('请先选择要上传的文件')
    }
  };

  const number = () =>{
    message.error('只能上传5个教辅工具')
  }

  return (
    <div>
      <div className='oss'>

        <div className='xuanZe' style={{ backgroundImage: `url(${img})` }}>
          <input type="file" id="fileupload" onChange={ fuJian?.length==5? number :handleFileChange} />
        </div>

        <div>
          <button>{props.buttonName}</button>
          {props.buttonName == '上传申报表' ? <button> <a href="https://obs-bj3.cucloud.cn/qiyeweike/www/%E8%AF%BE%E7%A8%8B%E7%94%B3%E6%8A%A5%E8%A1%A8.wps">下载申报表</a></button> : ''}
        </div>

      </div>

      {
        arr?.map((item, index) => {
          return <div className='ming' key={index}>
            <p title={item} key={index}>{item}</p>
            {arr.length ? <Progress percent={percent} /> : ''}
          </div>
        })
      }
    </div>
  );
};

export default UploadComponent;
